import { styled, useTheme } from "@tamagui/core";
import { View } from "../primitives/View.mjs";
import { SkeletonNativeGradient } from "./SkeletonNativeGradient.mjs";
import { jsx } from "react/jsx-runtime";
const SkeletonContainer = styled(View, {
    name: "SunshineSkeleton",
    overflow: "hidden"
  }),
  SkeletonContent = styled(View, {
    backgroundColor: "$skeleton.gradient.start",
    height: "100%",
    name: "SkeletonContent",
    overflow: "hidden",
    width: "100%"
  }),
  Skeleton = SkeletonContainer.styleable((p, ref) => {
    const theme = useTheme();
    return /* @__PURE__ */jsx(SkeletonContainer, {
      ...p,
      overflow: "hidden",
      ref,
      children: /* @__PURE__ */jsx(SkeletonContent, {
        style: {
          // @ts-expect-error CSS variables are not supported in TS but it's still creating a stylesheet.
          "--linear-gradient-start": theme["skeleton.gradient.start"].variable,
          "--linear-gradient-stop": theme["skeleton.gradient.stop"].variable
        },
        children: /* @__PURE__ */jsx(SkeletonNativeGradient, {})
      })
    });
  }),
  Bar = styled(Skeleton, {
    borderRadius: "$skeleton.bar.radius",
    defaultVariants: {
      size: "big"
    },
    name: "SunshineSkeleton.Bar",
    variants: {
      size: {
        big: {
          height: "$skeleton.bar.height.big"
        },
        small: {
          height: "$skeleton.bar.height.small"
        }
      }
    },
    width: "100%"
  }),
  Square = styled(Skeleton, {
    borderRadius: "$skeleton.square.radius",
    defaultVariants: {
      size: "big"
    },
    name: "SunshineSkeleton.Square",
    variants: {
      size: {
        "...size": (val, {
          tokens
        }) => ({
          aspectRatio: 1,
          height: tokens.size[val]
        }),
        big: {
          height: "$skeleton.square.size.big",
          width: "$skeleton.square.size.big"
        },
        small: {
          height: "$skeleton.square.size.small",
          width: "$skeleton.square.size.small"
        }
      }
    }
  }),
  SkeletonWithProperties = Skeleton;
SkeletonWithProperties.Bar = Bar;
SkeletonWithProperties.Square = Square;
SkeletonWithProperties.Square.displayName = "Skeleton.Square";
SkeletonWithProperties.Bar.displayName = "Skeleton.Bar";
SkeletonWithProperties.displayName = "Skeleton";
export { SkeletonWithProperties as Skeleton, SkeletonContent };
//# sourceMappingURL=Skeleton.mjs.map
